var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "h-100 d-flex flex-column p-2 pt-lg-0",
      staticStyle: { "transition-delay": "0s" },
      attrs: { id: "messages" }
    },
    [
      _c(
        "div",
        {
          staticClass: "row p-2 pt-0 p-lg-2 pt-lg-0",
          staticStyle: { "padding-top": "0px !important" }
        },
        [
          _c("div", { staticClass: "card text-left mb-4 col-12 p-0 m-0" }, [
            _c("h4", { staticClass: "card-header" }, [_vm._v("Send Kudos!")]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body p-3" }, [
              _c(
                "form",
                [
                  _c("transition-group", { attrs: { name: "slide-up" } }, [
                    !_vm.selectedUser
                      ? _c(
                          "div",
                          {
                            key: "search",
                            staticClass: "user-search-container"
                          },
                          [
                            _c("i", { staticClass: "fas fa-search" }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userSearch,
                                  expression: "userSearch"
                                },
                                {
                                  name: "debounce",
                                  rawName: "v-debounce:300ms",
                                  value: _vm.searchUser,
                                  expression: "searchUser",
                                  arg: "300ms"
                                }
                              ],
                              staticClass: "form-control user-search",
                              attrs: {
                                type: "text",
                                value: "",
                                placeholder: "Search by name"
                              },
                              domProps: { value: _vm.userSearch },
                              on: {
                                keydown: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.searchUser.apply(null, arguments)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.userSearch = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("transition", { attrs: { name: "slide-up" } }, [
                              _c(
                                "section",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.userSearch &&
                                        _vm.userSearch.length >= 3,
                                      expression:
                                        "userSearch && userSearch.length >= 3"
                                    }
                                  ],
                                  key: "user-list",
                                  attrs: { id: "user-list" }
                                },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "list-group" },
                                    _vm._l(_vm.users, function(user) {
                                      return _vm.users
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "list-group-item list-group-item-action",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectUser(user)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(user.first_name) +
                                                  " " +
                                                  _vm._s(user.last_name)
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.userSearch ||
                                      _vm.userSearch.length < 3,
                                    expression:
                                      "!userSearch || userSearch.length < 3"
                                  }
                                ],
                                staticClass: "alert alert-warning mt-4 mb-0"
                              },
                              [
                                _vm._v(
                                  "\n                                Let us know if a colleague or friend deserves recognition, a pick me up or even help by giving them Kudos!\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _c("div", { key: "form" }, [
                          _c("h5", [
                            _vm._v("Give "),
                            _c(
                              "a",
                              {
                                staticClass: "badge badge-primary bg-primary",
                                on: {
                                  click: function($event) {
                                    _vm.selectedUser = null
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.selectedUser.first_name))]
                            ),
                            _vm._v(" Kudos!")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.message,
                                expression: "message"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { rows: "6" },
                            domProps: { value: _vm.message },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.message = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-warning mt-4 font-italic"
                            },
                            [_vm._v(_vm._s(_vm.meaning))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12 text-right" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.disableSend
                                  },
                                  on: { click: _vm.sendKudos }
                                },
                                [_vm._v("Send")]
                              )
                            ])
                          ])
                        ])
                  ])
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("Kudos", {
        staticClass: "row flex-grow-1 p-2 p-lg-1",
        attrs: { user: _vm.user, limit: "10" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4798c908", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4798c908","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messages.vue
// module id = null
// module chunks = 